import React from 'react';
import { useFeature } from 'bv-hooks';
import withLazyLoad from 'bv-lazy-load';

const LazyUserInboxIcon = withLazyLoad()('userInboxIcon');

export default () => {
  const [userInboxEnabled] = useFeature('customer_inbox');

  if (userInboxEnabled) return <LazyUserInboxIcon />;
  return null;
};
